<template>
  <div class="info-panel" :class="{ 'info-panel-collapsed': collapsed }">
    <!-- 面板控制栏 -->
    <div class="panel-control">
      <h4 class="panel-title">
        <i class="el-icon-info"></i>
        桥梁信息
      </h4>
      <div class="panel-actions">
        <!-- 保存按钮 - 仅在未收起时显示 -->
        <el-button 
          v-if="!collapsed && (isEdit || true)"
          type="primary" 
          size="mini"
          icon="el-icon-check" 
          @click="save" 
          :loading="submitting"
          class="save-btn">保存</el-button>
        
        <el-tooltip :content="collapsed ? '展开' : '收起'" placement="top">
          <i 
            :class="collapsed ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'" 
            class="collapse-icon"
            @click="toggleCollapse">
          </i>
        </el-tooltip>
      </div>
    </div>

    <!-- 面板内容区域 -->
    <div class="panel-content" v-show="!collapsed">
      <div v-if="loading" class="panel-loading">
        <el-skeleton :rows="3" animated />
      </div>
      <template v-else>
        <!-- 使用传入的表单组件 -->
        <slot></slot>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BridgeInfoPanel',
  props: {
    // 是否处于加载状态
    loading: {
      type: Boolean,
      default: false
    },
    // 是否为编辑模式
    isEdit: {
      type: Boolean,
      default: false
    },
    // 是否正在提交
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 是否收起面板
      collapsed: false
    };
  },
  methods: {
    // 切换面板收起状态
    toggleCollapse() {
      this.collapsed = !this.collapsed;
      this.$emit('collapse-change', this.collapsed);
      
      // 给地图组件留出时间调整布局
      setTimeout(() => {
        // 通知地图组件更新大小
        this.$emit('layout-change');
      }, 300);
    },
    
    // 保存表单
    save() {
      this.$emit('save');
    }
  }
};
</script>

<style scoped>
.info-panel {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 360px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 10;
  max-height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
}

.info-panel-collapsed {
  width: auto;
  background-color: rgba(255, 255, 255, 0.9);
}

.panel-control {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #ebeef5;
  background-color: #f5f7fa;
  border-radius: 4px 4px 0 0;
}

.panel-title {
  margin: 0;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.panel-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.save-btn {
  padding: 5px 10px;
  height: 28px;
  line-height: 1;
}

.collapse-icon {
  cursor: pointer;
  font-size: 16px;
  color: #606266;
  padding: 5px;
}

.collapse-icon:hover {
  color: #409EFF;
}

.panel-content {
  padding: 15px;
  overflow-y: auto;
  flex-grow: 1;
}

.panel-loading {
  padding: 20px 0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .info-panel {
    width: 300px;
    left: 0;
    top: 0;
    height: 100%;
    max-height: none;
    border-radius: 0;
  }
  
  .info-panel-collapsed {
    transform: translateX(-100%);
  }
}
</style> 